import {H3Text, H6Text} from '@buncha/components/core/text';
import {useColorThemeType, useFontTheme} from '@buncha/appStyles/hooks/theme';

import BottomSheet from '@buncha/components/composites/bottomSheet';
import {Box} from '@buncha/components/core/view';
import {PButton} from '@buncha/components/core/Button';
import React from 'react';
import {StyleSheet} from 'react-native';
import font from '@buncha/appStyles/style/font';

interface TitleSubTitleBottomSheetProps {
  title: string;
  subtitle: string;
  ctaText: string;
  onCTAPress: () => void;
  open: boolean;
  onClose: () => void;
  ctaColor?: string;
  loading?: boolean;
}

const TitleSubTitleBottomSheet: React.FC<
  TitleSubTitleBottomSheetProps
> = props => {
  const theme = useColorThemeType('main');
  const mortise = useFontTheme('mortise');
  const muli = useFontTheme('muli');
  const title = props?.title ?? '';
  const subtitle = props?.subtitle ?? '';
  const buttonText = props?.ctaText ?? '';
  return (
    <BottomSheet open={props?.open} onClose={props?.onClose}>
      <Box style={styles.parentBox}>
        <H3Text
          style={[
            styles.align,
            {
              color: theme?.text?.blue?.[300],
              fontFamily: mortise?.[700]?.normal,
            },
          ]}>
          {title}
        </H3Text>
        <H6Text
          style={[
            styles.align,
            {color: theme?.text?.gray?.[100], fontFamily: muli?.[700]?.normal},
          ]}>
          {subtitle}
        </H6Text>
        <PButton
          isLoading={props?.loading}
          onPress={props?.onCTAPress}
          titleStyle={{
            ...font.FontSize.fontH5,
          }}
          style={[
            styles.cta,
            {
              backgroundColor:
                props?.ctaColor ?? theme?.background?.green?.[100],
            },
          ]}
          title={buttonText}
        />
      </Box>
    </BottomSheet>
  );
};

export default React.memo(TitleSubTitleBottomSheet);

const styles = StyleSheet.create({
  parentBox: {
    padding: 15,
    gap: 15,
  },
  align: {
    textAlign: 'left',
  },
  cta: {
    borderRadius: 100,
  },
});
